import { render, staticRenderFns } from "./DangerZone.vue?vue&type=template&id=54b91ff4&scoped=true&"
import script from "./DangerZone.vue?vue&type=script&lang=js&"
export * from "./DangerZone.vue?vue&type=script&lang=js&"
import style0 from "./DangerZone.vue?vue&type=style&index=0&id=54b91ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b91ff4",
  null
  
)

export default component.exports